import { render, staticRenderFns } from "./MediaEmbedVimeo.vue?vue&type=template&id=1ef76266&scoped=true&"
import script from "./MediaEmbedVimeo.vue?vue&type=script&lang=js&"
export * from "./MediaEmbedVimeo.vue?vue&type=script&lang=js&"
import style0 from "./MediaEmbedVimeo.vue?vue&type=style&index=0&id=1ef76266&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef76266",
  null
  
)

export default component.exports